import { Beneficiario } from './../modals/agregar-consulta-paciente/agregar-consulta-paciente.component';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { Service } from 'app/entities/servicios-backend';
import { Observable } from 'rxjs';
import { Eps } from '../entities/eps';
import { Sintoma } from '../entities/sintomas';
import { TipoServicio } from '../entities/tipo_servicio';
import { FormaPago } from '../entities/formas-pago';
import { Novedad } from '../entities/novedades';
import { MotivoCancelacion } from '../entities/motivo-cancel';
import { Socket } from 'ngx-socket-io';
import { Rellamadas } from '../entities/formulario-rellamada';
@Injectable({
  providedIn: 'root'
})
export class ServiciosService {

public trasladado;
public ordenCsc;
public servicioFinalizado: Observable<{csc: string}>;
public nuevaRellamada;
public newService;
/*
 *
 * Eventos de los sockets
 * @NuevoConsecutivo hace referencia al evento newCSC del api con sockets
*/
public nuevoConsecutivo;
constructor(private httpClient: HttpClient, private socketClient: Socket) {
  this.nuevoConsecutivo = this.socketClient.fromEvent<{campo: string, value: string, csc: string}>("edited service");
  this.trasladado = this.socketClient.fromEvent<{ csc: string; csctraslado: string; }>('csc trasladado');
  this.ordenCsc = this.socketClient.fromEvent<{ csc: string; orden: string; }>('csc trasladado');
  this.servicioFinalizado = this.socketClient.fromEvent<{csc: string}>('end service');
  this.nuevaRellamada = this.socketClient.fromEvent<{csc: any, cantidad: number}>('new rellamada');
  this.newService = this.socketClient.fromEvent<{servicio:Service}>("new service");
}

  /**
   * Obtener los servicios para el despacho
   */
  public getServicios() {
    return this.httpClient.get(`${environment.api}/servicios/getServicios`);
  }

  /**
   * Servicios activos
   */
  public getPrioridad() {
    return this.httpClient.get<Array<Service>>(`${environment.api}vital/servicios/activos/despacho`);
  }

  public getPrioridadDespacho(servicios) {
    return this.httpClient.post<Array<Service>>(`${environment.api}prioridades/prioridadesDespacho/`, servicios);
  }

  public getEquipos() {
    return this.httpClient.get(`${environment.informesdUrl}/controllers/informes_controller.php?accion=AsignarCelular`);
  }

  // Obtiene todos las eps que se tienen en la base de datos de la tabla afieps
  public getAllEps(): Observable<Array<Eps>>{
    return this.httpClient.get<Array<Eps>>(`${environment.api}vital/eps`);
  }

  // Se obtienen todos los sintomas que hay en la base de datos de la tabla sintomas
  getAllSintomas(): Observable<Array<Sintoma>>{
    return this.httpClient.get<Array<Sintoma>>(`${environment.api}vital/sintomas`);
  }
  // Obtiene todos los tipos de servicios que se tienen en la base de datos en la tabla tip_servicio
  getAllTipoServicios(): Observable<Array<TipoServicio>>{
    return this.httpClient.get<Array<TipoServicio>>(`${environment.api}vital/tipos/servicios`);
  }
  // Obtiene todas las formas de pago que hay en la base de datos en la tabla fpagomed
  formasDePago(): Observable<Array<FormaPago>>{
    return this.httpClient.get<Array<FormaPago>>(`${environment.api}vital/formas-pago`);
  }

  putFormasdePago(csc, fpg){
    return this.httpClient.put(`${environment.api}vital/formapago/${csc}/${fpg}`, {});
  }

  novedades(): Observable<Array<Novedad>>{
    return this.httpClient.get<Array<Novedad>>(`${environment.api}vital/novedades`);
  }

  cancelacion(): Observable<Array<MotivoCancelacion>>{
    return this.httpClient.get<Array<MotivoCancelacion>>(`${environment.api}vital/cancelacion`);
  }

  updateService(prop, campo, value, csc, formProps: Array<any>){
    this.socketClient.emit("edit service", {
      frontProp: prop,
      backProp: campo,
      value,
      csc,
      formProps,
      usuario:JSON.parse(localStorage.usuario).id_usuario
    });
  }

  updateBeneficiario(prop, campo, value, documento, formProps, csc){
    this.socketClient.emit("edit beneficiario", {
      frontProp: prop,
      backProp: campo,
      value,
      documento,
      formProps,
      csc
    });
  }

  cscTraslado(csc, csctraslado){
    this.socketClient.emit("csc traslado", {
      csc,
      csctraslado
    });
  }

  bitacorasms(form){
    console.log(form);
    
    return this.httpClient.post(`${environment.api}vital/bitacorasms`,{form})
  }
  // bitacorasms(form){
  //   this.socketClient.emit("csc traslado", {
  //     form
  //   });
  // }

  ordenCSC(csc, orden) {
    this.socketClient.emit("csc orden", {
      csc,
      orden
    });
  }



  updateTime(prop, campo, value, csc, formProps){
    const usuario = JSON.parse(localStorage.getItem("usuario"));

    this.socketClient.emit("set timestamp", {
      frontProp: prop,
      backProp: campo,
      value,
      csc,
      id_operador: usuario.id_usuario,
      formProps
    });
  }
  updateBeneficiarioAP(prop, campo, value, documento, formProps, csc){
    this.socketClient.emit("edit beneficiarioAP", {
      frontProp: prop,
      backProp: campo,
      value,
      documento,
      formProps,
      csc
    });
  }

  /* se obtiene los datos del equipo de la movil */
  movilDespacho(reqveh){
    return this.httpClient.get(`${environment.api}vital/movil/${reqveh}`);
  }

  codigosAmarillos(){
    return this.httpClient.get(`${environment.api }vital/codAmrillos`);
  }

  codigosRojos() {
    return this.httpClient.get(`${environment.api}vital/codRojos`);
  }

  codigosVerdes() {
    return this.httpClient.get(`${environment.api}vital/codVerdes`);
  }

  codigosAmarillosActivos(){
    return this.httpClient.get(`${environment.api }vital/codAmrillos/activos`);
  }

  codigosRojosActivos() {
    return this.httpClient.get(`${environment.api}vital/codRojos/activos`);
  }

  codigosVerdesActivos() {
    return this.httpClient.get(`${environment.api}vital/codVerdes/activos`);
  }

  totalServiciosDia() {
    return this.httpClient.get(`${environment.api}vital/totalserviciosdia`);
  }

  servicioscancelados(){
    return this.httpClient.get(`${environment.api}vital/canceladas`);
  }

  servicioscontraslado() {
    return this.httpClient.get(`${environment.api}vital/contraslado`);
  }

  sinDespacho(){
    return this.httpClient.get(`${environment.api}vital/sindespacho`);
  }

  enProceso() {
    return this.httpClient.get(`${environment.api}vital/enProceso`);
  }

  pasadasDetiempo() {
    return this.httpClient.get(`${environment.api}vital/pasadasdetiempo`);
  }

  equivocadas(){
    return this.httpClient.get(`${environment.api}vital/equivocadas`);
  }

  manuales(){
    return this.httpClient.get(`${environment.api}vital/manuales`);
  }

  conlaApp(){
    return this.httpClient.get(`${environment.api}vital/conlaApp`);
  }

  masde100(){
    return this.httpClient.get(`${environment.api}vital/mas/cien/tiempo`)
  }

  trasladoprogramado(){
    return this.httpClient.get(`${environment.api}vital/trasladoprogramado`);
  }

  activasSinTerminar(){
    return this.httpClient.get(`${environment.api}vital/activasSinTerminar`);
  }

  activos(){
    return this.httpClient.get(`${environment.api}vital/consultasActivas`);
  }

  turnosActivos(){
      return this.httpClient.get(`${environment.api}vital/turnos/activos`)
  }

  en520(){
    return this.httpClient.get(`${environment.api}vital/en/520`)
  }
  enDespalsamiento(){
    return this.httpClient.get(`${environment.api}vital/enDespalasamiento`);
  }

  conTrasladoActivo(){
      return this.httpClient.get(`${environment.api}vital/conTrasladoActivo`);
  }

  /* se obtienen todos lo servicios que ha tenido una persona */
  totalServicios<T>(bendoc):Observable<T>{
    return this.httpClient.get<T | any>(`${environment.api}vital/totalconsultas/${bendoc}`);
  }

  /* obtiene los datos de estado del contrato del beneficiario, de la tabla bit_contratos */
  bitacora(bendoc) {
    return this.httpClient.get(`${environment.api}vital/bitacora/${bendoc}`);
  }

  /* obtiene los datos (ID_PqrsMotivos, Motivo)  de la tabla pqrsmotivos */
  pqrs() {
    return this.httpClient.get(`${environment.api}vital/pqrs`);
  }

  sms() {
    return this.httpClient.get(`${environment.api}vital/sms`)
  }

  enviarsms(numero, descripcion){
    return this.httpClient.post(`${environment.api}sms/enviarMensaje/`, { numeros: numero, mensaje: descripcion })
  }

  smsEvaluacion() {
    return this.httpClient.get(`${environment.api}vital/smsevaluacion`)
  }

  smscount(csc){
    return this.httpClient.get(`${environment.api}vital/smscount/${csc}`)
  }

  enviarsmsevaluacion(numero, descripcion) {
    return this.httpClient.post(`${environment.api}sms/enviarMensaje/`, { numeros: numero, mensaje: descripcion })
  }

  rellamadasOfAService(csc): Observable<Array<Rellamadas>>{
    return this.httpClient.get<Array<Rellamadas>>(`${environment.api}vital/rellamadas/${csc}`);
  }

  serviciosHistorico(){
    return this.httpClient.get(`${environment.api}vital/servicios/historico`);
  }

  nuevasRellamadas(formData){
    return this.httpClient.post(`${environment.api}vital/rellamadas`, formData);
  }

  getRellamadas(consecutivo){
    return this.httpClient.get(`${environment.api}vital/servicios/rellamadas/${consecutivo}`);
  }
  nuevasRellamadasEmit(csc, cantidad){
    this.socketClient.emit("new rellamada", {csc, cantidad});
  }

  codigosAP(){
    return this.httpClient.get(`${environment.api}vital/codigosAP`);
  }

  totalConsultasOfAP(doc){
    return this.httpClient.get(`${environment.api}vital/consultas/ap/${doc}`);
  }

  prioridadPorSintoma(usuario, consecutivo, prioridad){
    return this.httpClient.put(`${environment.api}vital/prioridadsintoma/${usuario}/${consecutivo}/${prioridad}`,{})
  }

  getPrioridadPorSintoma(csc){
      return this.httpClient.get(`${environment.api}vital/prioridad/${csc}/sintoma`)
  }

  serviciostiemposconsulta() {
    return this.httpClient.get(`${environment.api}vital/serviciostiemposconsulta`)
  }

  infocsc(csc){
    return this.httpClient.get(`${environment.api}vital/infoconsecutivo/${csc}`)
  }

  addService(beneficiario:Beneficiario){
      this.socketClient.emit("new service",{
          beneficiario:beneficiario.ID_Ben,
          opeador:JSON.parse(localStorage.usuario).id_usuario
      })
  }

  celmovil(celmovil, vehcod){
    return this.httpClient.put(`${environment.api}vital/celularmovil/${celmovil}/${vehcod}`,{})
  }

  cerrarTurno(VEHCOD){
      return this.httpClient.put(`${environment.api}vital/cerrarturno/${VEHCOD}`,{})
  }

  tiempoMuerto(){
      return this.httpClient.get(`${environment.api}vital/tiempomuerto`,{})
  }

  obtenerInfoEquipo(VEHCOD){
        return this.httpClient.get(`${environment.api}vital/obtenerInfoEquipo/${VEHCOD}`,{})
    }

    AperturaTurno(datos){
        return this.httpClient.post(`${environment.api}vital/AperturaTurno/`,datos)
    }

    aperturaMovil(VEHCOD){
        return this.httpClient.put(`${environment.api}vital/GenerarAperturaMovil/${VEHCOD}`,{})
    }

    medicos(){
        return this.httpClient.get(`${environment.api}vital/medicos`)
    }

    agregarMedico(VEHMED,VEHCOD){
        return this.httpClient.put(`${environment.api}vital/agregar/medico/${VEHMED}/${VEHCOD}`,{})
    }

    conductores(){
        return this.httpClient.get(`${environment.api}vital/conductores`)
    }

    agregarConductor(VEHCON,VEHCOD){
      return this.httpClient.put(`${environment.api}vital/agregar/conductor/${VEHCON}/${VEHCOD}`,{})
    }

    auxiliar(){
        return this.httpClient.get(`${environment.api}vital/auxiliares`)
    }

    agregarAuxiliar(VEHENF,VEHCOD){
      return this.httpClient.put(`${environment.api}vital/agregar/auxiliar/${VEHENF}/${VEHCOD}`,{})
    }
}
